// Shared primitives used across layout files.
import type { CSSProperties } from "react";

export interface PhotoProps {
  src?: string;
  fallback?: React.ReactNode;
  style?: CSSProperties;
  sepia?: boolean;
}

export const Photo = ({ src, fallback, style, sepia = false }: PhotoProps) => {
  if (src) {
    return (
      <div
        style={{
          ...style,
          backgroundImage: `url("${src}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: sepia ? "sepia(0.15) saturate(0.9)" : "none",
        }}
      />
    );
  }
  return <div style={style}>{fallback}</div>;
};

interface CoupleSilhouetteProps { tone: string; accent: string; bg: string; }
export const CoupleSilhouette = ({ tone, accent, bg }: CoupleSilhouetteProps) => (
  <svg viewBox="0 0 200 280" style={{ width: "100%", height: "100%", display: "block" }} preserveAspectRatio="xMidYMid slice">
    <rect width="200" height="280" fill={bg} />
    <g transform="translate(100 165)">
      <g transform="translate(-20 0)">
        <ellipse cx="0" cy="-50" rx="14" ry="17" fill={tone} opacity="0.85" />
        <path d="M-22 -32 Q -22 0 -16 50 L 16 50 Q 22 0 22 -32 Q 14 -38 0 -38 Q -14 -38 -22 -32 Z" fill={tone} opacity="0.85" />
      </g>
      <g transform="translate(20 0)">
        <ellipse cx="0" cy="-52" rx="13" ry="16" fill={tone} opacity="0.75" />
        <path d="M-13 -40 Q -25 -20 -30 30 L 30 30 Q 25 -20 13 -40 Z" fill={accent} opacity="0.4" />
        <path d="M-22 -34 Q -22 -10 -18 50 L 18 50 Q 22 -10 22 -34 Q 12 -40 0 -40 Q -12 -40 -22 -34 Z" fill={tone} opacity="0.85" />
      </g>
    </g>
  </svg>
);

interface MemorialSilhouetteProps { tone: string; accent: string; bg: string; }
export const MemorialSilhouette = ({ tone, accent, bg }: MemorialSilhouetteProps) => (
  <svg viewBox="0 0 200 280" style={{ width: "100%", height: "100%", display: "block" }} preserveAspectRatio="xMidYMid slice">
    <rect width="200" height="280" fill={bg} />
    <g transform="translate(100 180)">
      <rect x="-12" y="0" width="24" height="80" fill={tone} opacity="0.7" />
      <ellipse cx="0" cy="0" rx="12" ry="3" fill={tone} />
      <ellipse cx="0" cy="-10" rx="4" ry="12" fill={accent} opacity="0.9" />
      <ellipse cx="0" cy="-8" rx="2" ry="7" fill={bg} />
    </g>
  </svg>
);

export interface LayoutCtx {
  names: string;
  date: string;
  venue: string;
  accent: string;
  ink: string;
  bg: string;
  font: string;
  photo?: string;
  photos: string[];
}
